module.exports = __webpack_public_path__ + "static/img/kunlun.5438c2af.png";